import { logger } from 'shared/lib'
import { toastStore } from 'shared/ui'
import { InboxesPath } from 'entities/ExportRouters'
import { GreetingsApi } from 'entities/Greetings/api/greetings.ts'
import { showItemUsageModal } from 'features/ItemUsage/showItemUsageModal.tsx'

export const checkUsageGreetingVoice = async (ids: number[]) => {
  try {
    const results = await Promise.all(ids.map(GreetingsApi.greetingUsage))
    if (results.every((res) => !res.data.is_used)) {
      return false
    }
    const firstUsageItem = results.find((res) => res.data.is_used)

    if (firstUsageItem) {
      const { inboxes } = firstUsageItem.data

      const title = 'Unable to delete recording'
      const description =
        'This recording is used in one or more call flows. Remove it from all flows before deleting:'
      showItemUsageModal({
        title,
        description,
        items: inboxes.map((inbox) => ({
          key: `${inbox.team_id}-workflow-${inbox.workflow_id ?? ''}`,
          link: InboxesPath.inboxSmartCallFlow(inbox.team_id),
          icon: 'inboxes2',
          title: inbox.team_name,
        })),
      })

      return true
    } else {
      return false
    }
  } catch (e) {
    toastStore.add({ title: 'Something went wrong. Please try again.', type: 'error' })
    logger.error(e)
    return true
  }
}
